import React from "react";
import StackVisualizer from "../../components/StackVisualizer/StackVisualizer";
import { MACHINE_TYPES } from "../../variables/machineVariables";
import pathConstants from "../../constants/PathSimulation/pathSimulationConstants";
import { isNullOrUndefined } from "../../utils/generalValidators";

const EMPTY_STRING_SYMBOL = "λ";

const StandardCardContent = ({ path, wordTape, automatonType, language }) => {
  const wordLength = wordTape.length;
  const wordConsumedUntilPos = wordTape.substring(0, path.pos);
  const isWordFullyConsumed = path.pos === wordLength;

  let nextSymbol = "";
  if (isWordFullyConsumed) {
    nextSymbol = "";
  } else {
    const symbol = wordTape[path.pos];
    if (isNullOrUndefined(symbol) || symbol === "") {
      nextSymbol = EMPTY_STRING_SYMBOL;
    } else {
      nextSymbol = symbol;
    }
  }

  let tapeNextSymbolBorderStyle = "none";
  if (
    path.pos < wordLength &&
    nextSymbol !== EMPTY_STRING_SYMBOL &&
    nextSymbol !== ""
  ) {
    tapeNextSymbolBorderStyle = "2px solid black";
  }

  let stackContent = "";
  if (!isNullOrUndefined(path.stackContent)) {
    stackContent = path.stackContent;
  }

  const remaining = wordTape.substring(path.pos + 1);

  return (
    <>
      <div className="path-card__tape-display">
        <span className="tape-consumed">{wordConsumedUntilPos}</span>
        <span
          className="tape-next-symbol"
          style={{
            borderBottom: tapeNextSymbolBorderStyle,
          }}
        >
          {nextSymbol}
        </span>
        <span className="tape-remaining">{remaining}</span>
      </div>

      {/* Visualização da Pilha */}
      {automatonType === MACHINE_TYPES.AP && stackContent !== "" && (
        <div
          className="path-card__stack-display"
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              marginTop: "4px",
              marginRight: "5px",
            }}
          >
            {pathConstants.pathSimulation.constants.stack[language]}:{" "}
          </span>
          <StackVisualizer content={stackContent} />
        </div>
      )}
    </>
  );
};

export default StandardCardContent;
